<template>
  <div class="box_3 flex-col">
    <div class="box_5 flex-row justify-end">
      <img class="box_6" referrerpolicy="no-referrer" :src="require('@/assets/humanResources/img/ds_5.jpg')"/>
      <div class="text-wrapper_8 flex-col">
        <span class="text_24">人才政策</span>
        <span class="paragraph_0">人才是先河环保的第一资源。先河环保始终把人才作为企业发展的创业之本、竞争之本、发展之本。经过二十多年地不断发展已经形成了公开、公正、公平、尊重知识和人才的良好企业风气。公司以其独特的人才招聘战略、开阔的事业发展空间、优良的人才成长环境、有效的激励机制和人本的企业文化理念，是企业成为人才集聚的高地。</span>
        <span class="paragraph_11">用人原则：德才兼备，以德为先；用人之道：用人之愿、用人之潜、用人之长。</span>
      </div>
    </div>
    <div class="box_11 flex-col">
      <div class="group_5 flex-row justify-between">
        <div class="group_6 flex-col"></div>
        <div class="image-text_2 flex-row justify-between">
          <span class="text-group_2">薪酬福利</span>
          <div class="group_7 flex-col"></div>
        </div>
      </div>
      <div class="list_1 flex-row">
        <div class="list-items_1 flex-col"></div>
        <div class="list-items_2 flex-col"></div>
        <div class="list-items_3 flex-col"></div>
        <div class="list-items_4 flex-col"></div>
      </div>
      <div class="text-wrapper_9 flex-row">
        <span class="text_25">01</span> <span class="text_26">基本薪资</span>
        <span class="text_27">02</span> <span class="text_28">绩效奖金</span>
        <span class="text_29">03</span> <span class="text_30">全面福利</span>
        <span class="text_31">04</span> <span class="text_32">补充津贴</span>
      </div>
      <div class="image-wrapper_1 flex-row justify-between">
        <img class="image_3" referrerpolicy="no-referrer" :src="require('@/assets/humanResources/img/ds_0.png')"/>
        <img class="image_4" referrerpolicy="no-referrer" :src="require('@/assets/humanResources/img/ds_0.png')"/>
        <img class="image_5" referrerpolicy="no-referrer" :src="require('@/assets/humanResources/img/ds_0.png')"/>
        <img class="image_6" referrerpolicy="no-referrer" :src="require('@/assets/humanResources/img/ds_0.png')"/>
      </div>
      <div class="group_8 flex-row">
        <div class="image-text_3 flex-row justify-between">
          <img
              class="thumbnail_3"
              referrerpolicy="no-referrer"
              :src="require('@/assets/humanResources/img/tb0.png')"
          />
          <span class="text-group_3">行业具有竞争力的薪酬水平</span>
        </div>
        <div class="image-text_4 flex-row justify-between">
          <img
              class="thumbnail_4"
              referrerpolicy="no-referrer"
              :src="require('@/assets/humanResources/img/tb0.png')"
          />
          <span class="text-group_4">日常奖励</span>
        </div>
        <div class="image-text_5 flex-row justify-between">
          <img
              class="thumbnail_5"
              referrerpolicy="no-referrer"
              :src="require('@/assets/humanResources/img/tb0.png')"
          />
          <span class="text-group_5">专项奖励</span>
        </div>
        <div class="image-text_6 flex-row justify-between">
          <img
              class="thumbnail_6"
              referrerpolicy="no-referrer"
              :src="require('@/assets/humanResources/img/tb0.png')"
          />
          <span class="text-group_6">五险一金</span>
        </div>
        <div class="image-text_7 flex-row justify-between">
          <img
              class="thumbnail_7"
              referrerpolicy="no-referrer"
              :src="require('@/assets/humanResources/img/tb0.png')"
          />
          <span class="text-group_7">免费通勤</span>
        </div>
        <div class="image-text_8 flex-row justify-between">
          <img
              class="thumbnail_8"
              referrerpolicy="no-referrer"
              :src="require('@/assets/humanResources/img/tb0.png')"
          />
          <span class="text-group_8">通讯补贴</span>
        </div>
        <div class="image-text_9 flex-row justify-between">
          <img
              class="thumbnail_9"
              referrerpolicy="no-referrer"
              :src="require('@/assets/humanResources/img/tb0.png')"
          />
          <span class="text-group_9">出差补贴</span>
        </div>
      </div>
      <div class="group_9 flex-row">
        <div class="image-text_10 flex-row justify-between">
          <img
              class="thumbnail_10"
              referrerpolicy="no-referrer"
              :src="require('@/assets/humanResources/img/tb0.png')"
          />
          <span class="text-group_10">每年职评调薪机会</span>
        </div>
        <img
            class="thumbnail_11"
            referrerpolicy="no-referrer"
            :src="require('@/assets/humanResources/img/tb0.png')"
        />
        <span class="text_33">年度绩效奖励</span>
        <img
            class="thumbnail_12"
            referrerpolicy="no-referrer"
            :src="require('@/assets/humanResources/img/tb0.png')"
        />
        <span class="text_34">营销专项奖励</span>
        <div class="image-text_11 flex-row justify-between">
          <img
              class="thumbnail_13"
              referrerpolicy="no-referrer"
              :src="require('@/assets/humanResources/img/tb0.png')"
          />
          <span class="text-group_11">成本价午餐</span>
        </div>
        <div class="image-text_12 flex-row justify-between">
          <img
              class="thumbnail_14"
              referrerpolicy="no-referrer"
              :src="require('@/assets/humanResources/img/tb0.png')"
          />
          <span class="text-group_12">节假日福利</span>
        </div>
        <img
            class="thumbnail_15"
            referrerpolicy="no-referrer"
            :src="require('@/assets/humanResources/img/tb0.png')"
        />
        <span class="text_35">年度评优奖励</span>
        <img
            class="thumbnail_16"
            referrerpolicy="no-referrer"
            :src="require('@/assets/humanResources/img/tb0.png')"
        />
        <span class="text_36">年度业绩奖金</span>
      </div>
      <div class="group_10 flex-row">
        <img
            class="thumbnail_17"
            referrerpolicy="no-referrer"
            :src="require('@/assets/humanResources/img/tb0.png')"
        />
        <span class="text_37">技术专项奖励</span>
        <img
            class="thumbnail_18"
            referrerpolicy="no-referrer"
            :src="require('@/assets/humanResources/img/tb0.png')"
        />
        <span class="text_38">成本节约奖励</span>
        <div class="image-text_13 flex-row justify-between">
          <img
              class="thumbnail_19"
              referrerpolicy="no-referrer"
              :src="require('@/assets/humanResources/img/tb0.png')"
          />
          <span class="text-group_13">文体娱乐活动</span>
        </div>
      </div>
      <div class="image-text_14 flex-row justify-between">
        <img
            class="thumbnail_20"
            referrerpolicy="no-referrer"
            :src="require('@/assets/humanResources/img/tb0.png')"
        />
        <span class="text-group_14">利润贡献奖励</span>
      </div>
    </div>
    <div class="box_12 flex-row justify-between">
      <div class="block_1 flex-col"></div>
      <div class="image-text_15 flex-row justify-between">
        <span class="text-group_15">福利体系</span>
        <div class="box_13 flex-col"></div>
      </div>
    </div>
    <img class="box_14" referrerpolicy="no-referrer" :src="require('@/assets/humanResources/img/t_5.png')"/>

    <div class="box_15 flex-col">
      <div class="section_2 flex-row justify-between">
        <div class="box_16 flex-col"></div>
        <div class="image-text_19 flex-row justify-between">
          <span class="text-group_19">职场通道</span>
          <div class="block_2 flex-col"></div>
        </div>
      </div>
      <img class="section_3" referrerpolicy="no-referrer" :src="require('@/assets/humanResources/img/t_7.png')"/>
    </div>
    <div class="box_17 flex-row justify-between">
      <div class="section_5 flex-col"></div>
      <div class="image-text_20 flex-row justify-between">
        <span class="text-group_20">培养体系</span>
        <div class="block_4 flex-col"></div>
      </div>
    </div>
    <img class="text-wrapper_15" referrerpolicy="no-referrer" :src="require('@/assets/humanResources/img/t_8.png')"/>

    <div class="box_18 flex-col">
      <div class="group_14 flex-row justify-end">
        <span class="text_57">应届生培训</span>
        <div class="box_19 flex-col"></div>
        <div class="box_20 flex-col"></div>
      </div>
      <img class="text-wrapper_16" referrerpolicy="no-referrer" :src="require('@/assets/humanResources/img/t_9.png')"/>

    </div>
  </div>
</template>

<script>
export default {
  name: "talentPolicy"
}
</script>

<style scoped>
.box_3 {
  background-color: rgba(255, 255, 255, 1);
  position: relative;
  width: 1121px;
  height: 3340px;

.box_5 {
  position: relative;
  width: 850px;
  height: 307px;
  margin: 60px 0 0 0px;
}

.box_6 {
  width: 400px;
  height: 240px;
  position: relative;
  bottom: 127px;
  margin: 128px 0 0 0px;
}

.text-wrapper_8 {
  width: 400px;
  height: 264px;
  margin: 0px 0 0 31px;
}

.text_24 {
  width: 120px;
  height: 30px;
  overflow-wrap: break-word;
  color: rgba(30, 30, 30, 1);
  font-size: 26px;
  font-family: PingFangSC-Medium;
  font-weight: 500;
  text-align: left;
  white-space: nowrap;
  line-height: 30px;
}

.paragraph_0 {
  width: 660px;
  height: 35px;
  font-family: PingFangSC, PingFang SC;
  font-weight: 400;
  font-size: 18px;
  color: #1E1E1E;
  line-height: 30px;
  text-align: left;
  font-style: normal;
  margin-top: 38px;
}

.paragraph_11 {
  width: 814px;
  height: 22px;
  font-family: PingFangSC, PingFang SC;
  font-weight: 400;
  font-size: 18px;
  color: #1E1E1E;
  line-height: 0;
  text-align: left;
  font-style: normal;
  margin-top: 130px;
}

.box_11 {
  background-color: rgba(243, 251, 255, 1);
  width: 100%;
  height: 500px;
  justify-content: flex-center;
}

.group_5 {
  width: 178px;
  height: 48px;
  margin: 30px 0 0 470px;
}

.group_6 {
  width: 28px;
  height: 48px;
  background: url('../../../../assets/humanResources/img/z_1.png')
  0px 0px no-repeat;
  background-size: 29px 48px;
}

.image-text_2 {
  width: 141px;
  height: 48px;
}

.text-group_2 {
  width: 104px;
  height: 26px;
  overflow-wrap: break-word;
  color: rgba(30, 30, 30, 1);
  font-size: 26px;
  font-family: PingFangSC-Semibold;
  font-weight: 600;
  text-align: center;
  white-space: nowrap;
  line-height: 26px;
  margin-top: 11px;
}

.group_7 {
  width: 28px;
  height: 48px;
  background: url('../../../../assets/humanResources/img/y_1.png')
  0px 0px no-repeat;
  background-size: 29px 48px;
}

.list_1 {
  width: 1000px;
  height: 140px;
  justify-content: space-between;
  margin: 40px 0 0 24px;
}

.list-items_1 {
  width: 247px;
  height: 140px;
  margin-right: 27px;
  background: url("../../../../assets/humanResources/img/t_1.jpg") 100% no-repeat;
  background-size: 100% 100%;
  cursor: pointer;
  transition: all 0.5s;
}
.list-items_1:hover{
  transform: scale(1.1);
  max-width: 100%; /* 设置最大宽度为原始图片宽度，防止超出 */
  max-height: 100%; /* 设置最大高度为原始图片高度，防止超出 */
}

.list-items_2 {
  width: 247px;
  height: 140px;
  margin-right: 27px;
  background: url("../../../../assets/humanResources/img/t_2.jpg") 100% no-repeat;
  background-size: 100% 100%;
  cursor: pointer;
  transition: all 0.5s;
}
.list-items_2:hover{
  transform: scale(1.1);
  max-width: 100%; /* 设置最大宽度为原始图片宽度，防止超出 */
  max-height: 100%; /* 设置最大高度为原始图片高度，防止超出 */
}
.list-items_3 {
  width: 247px;
  height: 140px;
  margin-right: 27px;
  background: url("../../../../assets/humanResources/img/t_3.jpg") 100% no-repeat;
  background-size: 100% 100%;
  cursor: pointer;
  transition: all 0.5s;
}
.list-items_3:hover{
  transform: scale(1.1);
  max-width: 100%; /* 设置最大宽度为原始图片宽度，防止超出 */
  max-height: 100%; /* 设置最大高度为原始图片高度，防止超出 */
}
.list-items_4 {
  width: 247px;
  height: 140px;
  margin-right: 27px;
  background: url("../../../../assets/humanResources/img/t_4.jpg") 100% no-repeat;
  background-size: 100% 100%;
  cursor: pointer;
  transition: all 0.5s;
}
.list-items_4:hover{
  transform: scale(1.1);
  max-width: 100%; /* 设置最大宽度为原始图片宽度，防止超出 */
  max-height: 100%; /* 设置最大高度为原始图片高度，防止超出 */
}
.text-wrapper_9 {
  width: 1211px;
  height: 26px;
  margin: 25px 0 0 24px;
}

.text_25 {
  background-image: linear-gradient(
      170deg,
      rgba(157, 198, 255, 0.3) 0,
      rgba(0, 90, 214, 0.3) 100%
  );
  width: 65px;
  height: 45px;
  overflow-wrap: break-word;
  color: rgba(0, 90, 214, 1);
  font-size: 52px;
  font-family: Helvetica-Bold;
  font-weight: 700;
  text-align: left;
  white-space: nowrap;
  line-height: 45px;
  -webkit-background-clip: text;
  -webkit-text-fill-color: transparent;
  position: relative;
  bottom: 14px;
  right: 2px;
}

.text_26 {
  width: 80px;
  height: 20px;
  overflow-wrap: break-word;
  color: rgba(0, 45, 106, 1);
  font-size: 20px;
  font-family: PingFangSC-Medium;
  font-weight: 500;
  text-align: left;
  white-space: nowrap;
  line-height: 20px;
  margin: 6px 0 0 3px;
}

.text_27 {
  background-image: linear-gradient(
      170deg,
      rgba(157, 198, 255, 0.3) 0,
      rgba(0, 90, 214, 0.3) 100%
  );
  width: 65px;
  height: 45px;
  overflow-wrap: break-word;
  color: rgba(0, 90, 214, 1);
  font-size: 52px;
  font-family: Helvetica-Bold;
  font-weight: 700;
  text-align: left;
  white-space: nowrap;
  line-height: 45px;
  margin-left: 124px;
  -webkit-background-clip: text;
  -webkit-text-fill-color: transparent;
  position: relative;
  bottom: 14px;
  right: 2px;
}

.text_28 {
  width: 80px;
  height: 20px;
  overflow-wrap: break-word;
  color: rgba(0, 45, 106, 1);
  font-size: 20px;
  font-family: PingFangSC-Medium;
  font-weight: 500;
  text-align: left;
  white-space: nowrap;
  line-height: 20px;
  margin: 6px 0 0 3px;
}

.text_29 {
  background-image: linear-gradient(
      170deg,
      rgba(157, 198, 255, 0.3) 0,
      rgba(0, 90, 214, 0.3) 100%
  );
  width: 65px;
  height: 45px;
  overflow-wrap: break-word;
  color: rgba(0, 90, 214, 1);
  font-size: 52px;
  font-family: Helvetica-Bold;
  font-weight: 700;
  text-align: left;
  white-space: nowrap;
  line-height: 45px;
  margin-left: 128px;
  -webkit-background-clip: text;
  -webkit-text-fill-color: transparent;
  position: relative;
  bottom: 14px;
  right: 2px;
}

.text_30 {
  width: 80px;
  height: 20px;
  overflow-wrap: break-word;
  color: rgba(0, 45, 106, 1);
  font-size: 20px;
  font-family: PingFangSC-Medium;
  font-weight: 500;
  text-align: left;
  white-space: nowrap;
  line-height: 20px;
  margin: 6px 0 0 3px;
}

.text_31 {
  background-image: linear-gradient(
      170deg,
      rgba(157, 198, 255, 0.3) 0,
      rgba(0, 90, 214, 0.3) 100%
  );
  width: 65px;
  height: 45px;
  overflow-wrap: break-word;
  color: rgba(0, 90, 214, 1);
  font-size: 52px;
  font-family: Helvetica-Bold;
  font-weight: 700;
  text-align: left;
  white-space: nowrap;
  line-height: 45px;
  margin-left: 124px;
  -webkit-background-clip: text;
  -webkit-text-fill-color: transparent;
  position: relative;
  bottom: 14px;
  right: 2px;
}

.text_32 {
  width: 80px;
  height: 20px;
  overflow-wrap: break-word;
  color: rgba(0, 45, 106, 1);
  font-size: 20px;
  font-family: PingFangSC-Medium;
  font-weight: 500;
  text-align: left;
  white-space: nowrap;
  line-height: 20px;
  margin: 6px 0 0 3px;
}

.image-wrapper_1 {
  width: 1080px;
  height: 1px;
  margin: 17px 0 0 24px;
}

.image_3 {
  width: 247px;
  height: 1px;
}

.image_4 {
  width: 247px;
  height: 1px;
}

.image_5 {
  width: 247px;
  height: 1px;
}

.image_6 {
  width: 247px;
  height: 1px;
  margin-right: 10px;
}

.group_8 {
  width: 1120px;
  height: 18px;
  margin: 16px 0 0 24px;
}

.image-text_3 {
  width: 240px;
  height: 15px;
}

.thumbnail_3 {
  width: 14px;
  height: 14px;
  margin-top: 2px;
}

.text-group_3 {
  width: 216px;
  height: 18px;
  overflow-wrap: break-word;
  color: rgba(30, 30, 30, 1);
  font-size: 15px;
  font-weight: normal;
  text-align: left;
  white-space: nowrap;
  line-height: 18px;
}

.image-text_4 {
  width: 96px;
  height: 18px;
  margin-left: 35px;
}

.thumbnail_4 {
  width: 14px;
  height: 14px;
  margin-top: 2px;
}

.text-group_4 {
  width: 72px;
  height: 18px;
  overflow-wrap: break-word;
  color: rgba(30, 30, 30, 1);
  font-size: 15px;
  font-weight: normal;
  text-align: left;
  white-space: nowrap;
  line-height: 18px;
}

.image-text_5 {
  width: 96px;
  height: 18px;
  margin-left: 35px;
}

.thumbnail_5 {
  width: 14px;
  height: 14px;
  margin-top: 2px;
}

.text-group_5 {
  width: 72px;
  height: 18px;
  overflow-wrap: break-word;
  color: rgba(30, 30, 30, 1);
  font-size: 15px;
  font-weight: normal;
  text-align: left;
  white-space: nowrap;
  line-height: 18px;
}

.image-text_6 {
  width: 96px;
  height: 18px;
  margin-left: 45px;
}

.thumbnail_6 {
  width: 14px;
  height: 14px;
  margin-top: 2px;
}

.text-group_6 {
  width: 72px;
  height: 18px;
  overflow-wrap: break-word;
  color: rgba(30, 30, 30, 1);
  font-size: 15px;
  font-weight: normal;
  text-align: left;
  white-space: nowrap;
  line-height: 18px;
}

.image-text_7 {
  width: 96px;
  height: 18px;
  margin-left: 35px;
}

.thumbnail_7 {
  width: 14px;
  height: 14px;
  margin-top: 2px;
}

.text-group_7 {
  width: 72px;
  height: 18px;
  overflow-wrap: break-word;
  color: rgba(30, 30, 30, 1);
  font-size: 15px;
  font-weight: normal;
  text-align: left;
  white-space: nowrap;
  line-height: 18px;
}

.image-text_8 {
  width: 96px;
  height: 18px;
  margin-left: 48px;
}

.thumbnail_8 {
  width: 14px;
  height: 14px;
  margin-top: 2px;
}

.text-group_8 {
  width: 72px;
  height: 18px;
  overflow-wrap: break-word;
  color: rgba(30, 30, 30, 1);
  font-size: 15px;
  font-weight: normal;
  text-align: left;
  white-space: nowrap;
  line-height: 18px;
}

.image-text_9 {
  width: 96px;
  height: 18px;
  margin-left: 35px;
}

.thumbnail_9 {
  width: 14px;
  height: 14px;
  margin-top: 2px;
}

.text-group_9 {
  width: 72px;
  height: 18px;
  overflow-wrap: break-word;
  color: rgba(30, 30, 30, 1);
  font-size: 15px;
  font-weight: normal;
  text-align: left;
  white-space: nowrap;
  line-height: 18px;
}

.group_9 {
  width: 1120px;
  height: 18px;
  margin: 16px 0 0 24px;
}

.image-text_10 {
  width: 168px;
  height: 17px;
}

.thumbnail_10 {
  width: 14px;
  height: 14px;
  margin-top: 2px;
}

.text-group_10 {
  width: 144px;
  height: 18px;
  overflow-wrap: break-word;
  color: rgba(30, 30, 30, 1);
  font-size: 15px;
  font-weight: normal;
  text-align: left;
  white-space: nowrap;
  line-height: 18px;
}

.thumbnail_11 {
  width: 14px;
  height: 14px;
  margin: 2px 0 0 107px;
}

.text_33 {
  width: 108px;
  height: 18px;
  overflow-wrap: break-word;
  color: rgba(30, 30, 30, 1);
  font-size: 15px;
  font-weight: normal;
  text-align: left;
  white-space: nowrap;
  line-height: 18px;
  margin-left: 9px;
}

.thumbnail_12 {
  width: 14px;
  height: 14px;
  margin: 2px 0 0 1px;
}

.text_34 {
  width: 108px;
  height: 18px;
  overflow-wrap: break-word;
  color: rgba(30, 30, 30, 1);
  font-size: 15px;
  font-weight: normal;
  text-align: left;
  white-space: nowrap;
  line-height: 18px;
  margin-left: 9px;
}

.image-text_11 {
  width: 113px;
  height: 18px;
  margin-left: 10px;
}

.thumbnail_13 {
  width: 14px;
  height: 14px;
  margin-top: 2px;
}

.text-group_11 {
  width: 90px;
  height: 18px;
  overflow-wrap: break-word;
  color: rgba(30, 30, 30, 1);
  font-size: 15px;
  font-weight: normal;
  text-align: left;
  white-space: nowrap;
  line-height: 18px;
}

.image-text_12 {
  width: 113px;
  height: 18px;
  margin-left: 18px;
}

.thumbnail_14 {
  width: 14px;
  height: 14px;
  margin-top: 2px;
}

.text-group_12 {
  width: 90px;
  height: 18px;
  overflow-wrap: break-word;
  color: rgba(30, 30, 30, 1);
  font-size: 15px;
  font-weight: normal;
  text-align: left;
  white-space: nowrap;
  line-height: 18px;
}

.thumbnail_15 {
  width: 14px;
  height: 14px;
  margin: 2px 0 0 30px;
}

.text_35 {
  width: 108px;
  height: 18px;
  overflow-wrap: break-word;
  color: rgba(30, 30, 30, 1);
  font-size: 15px;
  font-weight: normal;
  text-align: left;
  white-space: nowrap;
  line-height: 18px;
  margin-left: 9px;
}

.thumbnail_16 {
  width: 14px;
  height: 14px;
  margin: 2px 0 0 1px;
}

.text_36 {
  width: 108px;
  height: 18px;
  overflow-wrap: break-word;
  color: rgba(30, 30, 30, 1);
  font-size: 15px;
  font-weight: normal;
  text-align: left;
  white-space: nowrap;
  line-height: 18px;
  margin-left: 9px;
}

.group_10 {
  width: 495px;
  height: 18px;
  margin: 16px 0 0 300px;
}

.thumbnail_17 {
  width: 14px;
  height: 14px;
  margin-top: 2px;
}

.text_37 {
  width: 108px;
  height: 18px;
  overflow-wrap: break-word;
  color: rgba(30, 30, 30, 1);
  font-size: 15px;
  font-weight: normal;
  text-align: left;
  white-space: nowrap;
  line-height: 18px;
  margin-left: 9px;
}

.thumbnail_18 {
  width: 14px;
  height: 14px;
  margin: 2px 0 0 1px;
}

.text_38 {
  width: 108px;
  height: 18px;
  overflow-wrap: break-word;
  color: rgba(30, 30, 30, 1);
  font-size: 15px;
  font-weight: normal;
  text-align: left;
  white-space: nowrap;
  line-height: 18px;
  margin-left: 9px;
}

.image-text_13 {
  width: 106px;
  height: 18px;
  margin-left: 10px;
}

.thumbnail_19 {
  width: 14px;
  height: 14px;
  margin-top: 2px;
}

.text-group_13 {
  width: 108px;
  height: 18px;
  overflow-wrap: break-word;
  color: rgba(30, 30, 30, 1);
  font-size: 15px;
  font-weight: normal;
  text-align: left;
  white-space: nowrap;
  line-height: 18px;
}

.image-text_14 {
  width: 135px;
  height: 18px;
  margin: 16px 0 50px 300px;
}

.thumbnail_20 {
  width: 14px;
  height: 14px;
  margin-top: 2px;
}

.text-group_14 {
  width: 144px;
  height: 18px;
  overflow-wrap: break-word;
  color: rgba(30, 30, 30, 1);
  font-size: 15px;
  font-weight: normal;
  text-align: left;
  white-space: nowrap;
  line-height: 18px;
}

.box_12 {
  width: 178px;
  height: 48px;
  margin: 30px 0 0 470px;
}

.block_1 {
  width: 28px;
  height: 48px;
  background: url('../../../../assets/humanResources/img/z_1.png')
  0px 0px no-repeat;
  background-size: 29px 48px;
}

.image-text_15 {
  width: 141px;
  height: 48px;
}

.text-group_15 {
  width: 104px;
  height: 26px;
  overflow-wrap: break-word;
  color: rgba(30, 30, 30, 1);
  font-size: 26px;
  font-family: PingFangSC-Semibold;
  font-weight: 600;
  text-align: center;
  white-space: nowrap;
  line-height: 26px;
  margin-top: 11px;
}

.box_13 {
  width: 28px;
  height: 48px;
  background: url('../../../../assets/humanResources/img/y_1.png')
  0px 0px no-repeat;
  background-size: 29px 48px;
}

.image-text_16 {
  width: 192px;
  height: 70px;
  margin: 50px 0 0 925px;
}

.image-wrapper_2 {
  background-color: rgba(30, 123, 254, 1);
  border-radius: 50%;
  height: 70px;
  width: 70px;
}

.label_2 {
  width: 40px;
  height: 35px;
  margin: 18px 0 0 15px;
}

.text-group_16 {
  width: 104px;
  height: 26px;
  overflow-wrap: break-word;
  color: rgba(30, 30, 30, 1);
  font-size: 26px;
  font-family: PingFangSC-Medium;
  font-weight: 500;
  text-align: left;
  white-space: nowrap;
  line-height: 26px;
  margin-top: 20px;
}

.text-wrapper_10 {
  width: 1010px;
  height: 26px;
  margin: 92px 0 0 446px;
  position: relative;
  bottom: 47px;
}

.text_39 {
  width: 104px;
  height: 26px;
  overflow-wrap: break-word;
  color: rgba(30, 30, 30, 1);
  font-size: 26px;
  font-family: PingFangSC-Medium;
  font-weight: 500;
  text-align: left;
  white-space: nowrap;
  line-height: 26px;
}

.text_40 {
  width: 104px;
  height: 26px;
  overflow-wrap: break-word;
  color: rgba(30, 30, 30, 1);
  font-size: 26px;
  font-family: PingFangSC-Medium;
  font-weight: 500;
  text-align: left;
  white-space: nowrap;
  line-height: 26px;
}

.text-wrapper_11 {
  width: 1288px;
  height: 26px;
  margin: 82px 0 0 315px;
  position: relative;
  bottom: 48px;
}

.text_41 {
  width: 130px;
  height: 26px;
  overflow-wrap: break-word;
  color: rgba(30, 30, 30, 1);
  font-size: 26px;
  font-family: PingFangSC-Medium;
  font-weight: 500;
  text-align: right;
  white-space: nowrap;
  line-height: 26px;
}

.text_42 {
  width: 130px;
  height: 26px;
  overflow-wrap: break-word;
  color: rgba(30, 30, 30, 1);
  font-size: 26px;
  font-family: PingFangSC-Medium;
  font-weight: 500;
  text-align: left;
  white-space: nowrap;
  line-height: 26px;
}

.box_14 {
  width: 1050px;
  margin: 86px 0 0 24px;
  position: relative;
  bottom: 47px;
}

.box_15 {
  background-color: rgba(243, 251, 255, 1);
  height: 700px;
  margin-top: 20px;
  width: 100%;
}

.section_2 {
  width: 178px;
  height: 48px;
  margin: 30px 0 0 470px;
}

.box_16 {
  width: 28px;
  height: 48px;
  background: url('../../../../assets/humanResources/img/z_1.png')
  0px 0px no-repeat;
  background-size: 29px 48px;
}

.image-text_19 {
  width: 141px;
  height: 48px;
}

.text-group_19 {
  width: 104px;
  height: 26px;
  overflow-wrap: break-word;
  color: rgba(30, 30, 30, 1);
  font-size: 26px;
  font-family: PingFangSC-Semibold;
  font-weight: 600;
  text-align: center;
  white-space: nowrap;
  line-height: 26px;
  margin-top: 11px;
}

.block_2 {
  width: 28px;
  height: 48px;
  background: url('../../../../assets/humanResources/img/y_1.png')
  0px 0px no-repeat;
  background-size: 29px 48px;
}

.section_3 {
  width: 1050px;
  margin: 28px 0 0 38px;
  position: relative;
}

.box_17 {
  width: 178px;
  height: 48px;
  margin: 30px 0 0 470px;
}

.section_5 {
  width: 28px;
  height: 48px;
  background: url('../../../../assets/humanResources/img/z_1.png')
  0px 0px no-repeat;
  background-size: 29px 48px;
}

.image-text_20 {
  width: 141px;
  height: 48px;
}

.text-group_20 {
  width: 104px;
  height: 26px;
  overflow-wrap: break-word;
  color: rgba(30, 30, 30, 1);
  font-size: 26px;
  font-family: PingFangSC-Semibold;
  font-weight: 600;
  text-align: center;
  white-space: nowrap;
  line-height: 26px;
  margin-top: 11px;
}

.block_4 {
  width: 28px;
  height: 48px;
  background: url('../../../../assets/humanResources/img/y_1.png')
  0px 0px no-repeat;
  background-size: 29px 48px;
}

.text-wrapper_15 {
  width: 1050px;
  margin: 50px 0 0 38px;
}

.box_18 {
  background-color: rgba(249, 249, 249, 1);
  height: 700px;
  margin-top: 20px;
  width: 100%;
}

.group_14 {
  position: relative;
  width: 178px;
  height: 48px;
  margin: 30px 0 0 470px;
}

.text_57 {
  width: 130px;
  height: 26px;
  overflow-wrap: break-word;
  color: rgba(30, 30, 30, 1);
  font-size: 26px;
  font-family: PingFangSC-Semibold;
  font-weight: 600;
  text-align: center;
  white-space: nowrap;
  line-height: 26px;
  margin: 11px 0 0 24px;
}

.box_19 {
  width: 28px;
  height: 48px;
  background: url('../../../../assets/humanResources/img/y_1.png')
  0px 0px no-repeat;
  background-size: 29px 48px;
  margin-left: -4px;
}

.box_20 {
  position: absolute;
  left: 0;
  top: 0;
  width: 28px;
  height: 48px;
  background: url('../../../../assets/humanResources/img/z_1.png')
  0px 0px no-repeat;
  background-size: 29px 48px;
}

.text-wrapper_16 {
  width: 1050px;
  margin: 50px 0 0 38px;
}

}
</style>
